import React, { useCallback } from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Alert from "../../../../../../shared-components/css-modules/lexus/molecules/Alert";
import baseStyles from "../../../common/modals/availableInOtherGrades/OtherGradeModal.module.scss";
import type {
    AvailableGradesForConfigurableGradeType,
    WheelFromOtherGradesType,
} from "../../../../../../../shared-logic/types/AvailableInOtherGradesType";
import useAphAvailableInOtherGrades from "../../../../../hooks/useAphAvailableInOtherGrades";
import { useCarConfigSelector } from "../../../../../redux/store";
import GradeCard from "../../../common/modals/availableInOtherGrades/GradeCard";
import { CarConfigLabel } from "../../../../../utils/labelUtils";

const WheelOtherGradesModal: React.FC<{ wheel: WheelFromOtherGradesType }> = ({ wheel }) => {
    const { grade, model } = useCarConfigSelector((state) => state.car);

    const { isActive, availableGradesForConfigurable, selectedGrade, setSelectedGrade } =
        useAphAvailableInOtherGrades();

    const onClickHandler = useCallback(
        (availableGrade: AvailableGradesForConfigurableGradeType) => {
            if (!isActive(availableGrade.id)) setSelectedGrade(availableGrade);
        },
        [isActive, setSelectedGrade],
    );

    if (!availableGradesForConfigurable) return null;

    return (
        <>
            <div className={baseStyles.intro}>
                <Text tag="h2" variant="apheleia-h4">
                    {wheel.name}
                </Text>
                <Text tag="p" variant="apheleia-body">
                    <CarConfigLabel
                        label={
                            availableGradesForConfigurable.grades.length > 1
                                ? "carConfigSelectAvailableWheelInOtherGrade"
                                : "carConfigSelectAvailableWheelInOtherGrades"
                        }
                        params={{
                            model: model.webtitleSectionName,
                            currentGrade: grade.webtitleSectionName,
                            newGrade: selectedGrade?.name,
                        }}
                    />
                </Text>
            </div>
            <Alert icon="info">
                <CarConfigLabel label="carConfigSelectAvailableItemInOtherGradeWarning" />
            </Alert>
            <div className={baseStyles.gradelist}>
                {selectedGrade &&
                    availableGradesForConfigurable.grades.map((availableGrade) => (
                        <GradeCard
                            onClickHandler={onClickHandler}
                            key={availableGrade.id}
                            availableGrade={availableGrade}
                            isActive={isActive(availableGrade.id)}
                        />
                    ))}
            </div>
        </>
    );
};

export default WheelOtherGradesModal;
